import httpApi from './httpApi.js'; // 接口
import Vue from 'vue'
Vue.use(httpApi);
